module.exports = __webpack_public_path__ + "static/media/Stormwater2.8beb1257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stormwater2.jpg
// module id = 734
// module chunks = 0